const inrFmt = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function inr(value) {
  const n = Number(value || 0);
  return `₹${inrFmt.format(Math.abs(n) < 0.005 ? 0 : n)}`;
}

export function num(value, digits = 2) {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(value || 0));
}

export function compactInr(value) {
  const n = Number(value || 0);
  if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (Math.abs(n) >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return inr(n);
}

export function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(`${String(d).slice(0, 10)}T00:00:00`);
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

export function addDays(dateStr, days) {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function financialYear(dateStr = today()) {
  const d = new Date(`${dateStr}T00:00:00`);
  const y = d.getMonth() + 1 >= 4 ? d.getFullYear() : d.getFullYear() - 1;
  return `${y}-${String(y + 1).slice(-2)}`;
}

export function fyBounds(fy = financialYear()) {
  const y = Number(fy.split("-")[0]);
  return { from: `${y}-04-01`, to: `${y + 1}-03-31` };
}

export const DOC_LABEL = {
  SALES_INVOICE: "Tax Invoice",
  BILL_OF_SUPPLY: "Bill of Supply",
  CREDIT_NOTE: "Credit Note",
};

export const PAYMENT_MODES = ["CASH", "BANK_TRANSFER", "UPI", "CHEQUE", "CARD", "NEFT", "RTGS", "IMPS", "OTHER"];

export function titleCase(s) {
  return String(s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

// India is the only country this bills for, so a bare ten-digit mobile is an
// Indian one.
export const ISD_CODE = "91";

/**
 * A number in the form wa.me wants: country code, digits only, no plus.
 *
 * Without the code, wa.me takes a ten-digit number as incomplete and opens a
 * chat with nobody — the message looks sent and never arrives. Older records
 * typed as "+91 98220 33441" already carry it; one captured at the counter as
 * "9822033441" does not, and both have to end up the same.
 */
export function waNumber(phone) {
  let d = String(phone || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("00")) d = d.slice(2);                  // 0091 98765 43210
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1); // 0 98765 43210, STD style
  if (d.length === 10) return ISD_CODE + d;                 // the usual case
  return d;                                                 // already has a code
}

/** Ten digits stored the way the rest of the records read: +91 98765 43210. */
export function formatIndianMobile(raw) {
  const d = String(raw || "").replace(/\D/g, "").slice(-10);
  return d.length === 10 ? `+${ISD_CODE} ${d.slice(0, 5)} ${d.slice(5)}` : String(raw || "").trim();
}
